import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";
import { DecisionPage, DecisionState } from "../../../models/home";
import { HomeDecisionActionUxService } from "../../../services/home-ia/home-decision-action-ux.service";
import { HomeDecisionDisplayUxService } from "../../../services/home-ia/home-decision-display-ux.service";
import { LanguageService } from "../../../services/language/language.service";
import { UxError } from "../../../models/ux-error.model";
import { formatDecisionTitle } from "../../../utils/decision-title-format.util";

type DecisionStateFilter = DecisionState | "all" | "attention";

@Component({
  selector: "app-home-decision-list",
  templateUrl: "./home-decision-list.component.html",
  styleUrls: ["./home-decision-list.component.scss"],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HomeDecisionListComponent {
  @Input() page: DecisionPage | null = null;
  @Input() loading = false;
  @Input() error: UxError | null = null;
  @Input() activeState: DecisionStateFilter = "all";
  @Input() selectedDecisionId: string | null = null;
  @Output() retryRequest = new EventEmitter<void>();
  @Output() selectDecision = new EventEmitter<string>();
  readonly formatDecisionTitle = formatDecisionTitle;

  constructor(
    public readonly lang: LanguageService,
    private readonly actionUx: HomeDecisionActionUxService,
    private readonly decisionDisplayUx: HomeDecisionDisplayUxService
  ) {}

  get titleKey(): string {
    return this.activeState === "all" ? "home.decisionList.title" : "home.decisionList.filteredTitle";
  }

  get emptyKey(): string {
    return this.activeState === "all" ? "home.decisionList.empty" : "home.decisionList.emptyFiltered";
  }

  getStateLabel(state: DecisionState): string {
    return this.lang.translate(`home.decisionStates.${state}`);
  }

  getActionMetaLabel(item: DecisionPage["items"][number]): string | null {
    return this.actionUx.getListActionLabel(item);
  }

  getPriorityMetaLabel(item: DecisionPage["items"][number]): string {
    return this.decisionDisplayUx.getPriorityBadgeLabel(item.priority, item.state, item.dueAt);
  }

  onRetry(): void {
    this.retryRequest.emit();
  }

  onSelectDecision(decisionId: string): void {
    this.selectDecision.emit(decisionId);
  }

  trackByDecisionId(_: number, item: DecisionPage["items"][number]): string {
    return item.decisionId;
  }
}
